import { TimingEvent } from '@/gen/marketDataApi'

import { cn } from '@/utils/cn'

import { StatusCircle } from '../statusCircle'
import { Tooltip, TooltipContent, TooltipTrigger } from '../tooltip'

interface Props {
    className?: string
    state: TimingEvent
}

const circles = {
    None: <StatusCircle variant="outline" />,
    Init: <StatusCircle variant="secondary" />,
    PreOpen: <StatusCircle variant="success-outline" />,
    Open: <StatusCircle variant="success" />,
    PreClose: <StatusCircle variant="warning-outline" />,
    Close: <StatusCircle variant="warning" />,
    Down: <StatusCircle variant="destructive" />,
    Enquiry: <StatusCircle variant="outline" />,
}

export default function TimingEventCircle({ className, state }: Props) {
    const Cmp = circles[state]
    return (
        <Tooltip>
            <TooltipTrigger>
                <div className={cn(className)}>{Cmp}</div>
            </TooltipTrigger>
            <TooltipContent>{state}</TooltipContent>
        </Tooltip>
    )
}
